import './ProvidersShowModalAction.css';

import React                     from 'react';
import { useEffect }             from 'react';
import { useState }              from 'react';
import { observer }              from 'mobx-react';
import { Button }                from 'antd';
import { AppstoreOutlined }      from '@ant-design/icons';
import { AppForm }               from 'components/App/AppForm';
import { AppFormInjectedProps }  from 'components/App/AppForm';
import ProviderShowComponent     from 'containers/Show/components/ProviderShowComponent';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import { ApiCollection }         from 'collections/ApiCollection';
import ProviderShowModel         from 'models/ProviderShowModel';
import ProviderShowCategoryModel from 'models/ProviderShowCategoryModel';
import ProviderModel             from 'models/ProviderModel';

interface ProvidersShowModalActionInternalProps {
  onClose: () => void;
  providerCollection: ApiCollection<ProviderModel>;
  providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;
  providerShowCollection: ApiCollection<ProviderShowModel>;
}

const ProvidersShowModalActionInternal = observer(
  ({
    closeModal,
    onClose,
    providerCollection,
    providerShowCategoryCollection,
    providerShowCollection,
    setModalFooter,
  }: ProvidersShowModalActionInternalProps & AppFormInjectedProps) => {
    useEffect(() => {
      setModalFooter([
        <Button key="close" onClick={closeModal}>
          <FormattedMessageWrapper id="Fermer" />
        </Button>,
      ]);
    }, [closeModal, setModalFooter]);

    // Prévient le déclencheur (bouton "Prestataires") de la fermeture de la modale,
    // pour qu'il puisse la rouvrir au clic suivant.
    useEffect(() => onClose, [onClose]);

    return (
      <div id="ProvidersShowModalActionContainer">
        {providerShowCategoryCollection.map((providerShowCategory: ProviderShowCategoryModel) => {
          const providerShows = providerShowCollection.models
            .slice()
            .filter(
              (providerShow: ProviderShowModel) => providerShow.providerShowCategoryIri === providerShowCategory.iri,
            );

          if (providerShows.length < 1) {
            return null;
          }

          return (
            <React.Fragment key={providerShowCategory.iri}>
              <div className="ProvidersShowModalAction__providerShowCategoryName">
                <strong>{providerShowCategory.providerShowCategoryName}</strong>
              </div>
              {providerShows.map((providerShow: ProviderShowModel) => (
                <ProviderShowComponent
                  key={providerShow.id}
                  providerCollection={providerCollection}
                  providerShow={providerShow}
                  providerShowCategory={providerShowCategory}
                  providerShowCategoryCollection={providerShowCategoryCollection}
                  withClicks={false}
                />
              ))}
            </React.Fragment>
          );
        })}
      </div>
    );
  },
);

interface ProvidersShowModalActionProps {
  providerCollection: ApiCollection<ProviderModel>;
  providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;
  providerShowCollection: ApiCollection<ProviderShowModel>;
}

const ProvidersShowModalAction = ({
  providerCollection,
  providerShowCategoryCollection,
  providerShowCollection,
}: ProvidersShowModalActionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (providerShowCollection.length < 1) {
    return null;
  }

  return (
    <Button
      className="ProviderShowModalAction__renderBtnContent"
      disabled={isOpen}
      onClick={() => {
        setIsOpen(true);
        AppForm.open(
          ProvidersShowModalActionInternal,
          {
            onClose: () => setIsOpen(false),
            providerCollection,
            providerShowCategoryCollection,
            providerShowCollection,
          },
          { title: <FormattedMessageWrapper id="Prestataires" /> },
        );
      }}
      style={{
        alignItems: 'center',
        display: 'flex',
      }}
      type="link"
    >
      <AppstoreOutlined />
      <span
        style={{
          color: 'rgba(255, 255, 255, 0.85)',
          margin: '0px 0px 0px 10px',
          padding: 0,
        }}
      >
        <FormattedMessageWrapper id="Prestataires" />
      </span>
    </Button>
  );
};

export default observer(ProvidersShowModalAction);
